import { createCookieConsent } from "@/utils/cookieConsent";

export default {
    install(Vue, options = {}) {
        const consent = createCookieConsent(options);
        Vue.prototype.$consent = consent;
    },
};
